"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DropdownList = _interopRequireDefault(require("../controls/dropdown/DropdownList"));
var _InnerButton = require("../controls/buttons/InnerButton");
var _StyledIcon = require("../media/icon/StyledIcon");
var _jsxRuntime = require("react/jsx-runtime");
var ContextMenu = function ContextMenu(_ref) {
  var contextMenuOptions = _ref.contextMenuOptions,
    iconColor = _ref.iconColor,
    changeOnHover = _ref.changeOnHover;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "context-menu",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_DropdownList.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Trigger, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.WrapperButtonWithFocusRing, {
          "data-cy": 'open-context-menu',
          "aria-label": 'Open context menu',
          focusRingColor: iconColor,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledIcon.StyledIcon, {
            icon: 'more',
            customColor: iconColor,
            size: 'l',
            changeOnHover: changeOnHover
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Content, {
        children: contextMenuOptions.map(function (option) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropdownList.default.Item, {
            onClick: option.onClick,
            disabled: option.disabled,
            "data-cy": "context-list-option-" + option.name.toLowerCase().replace(/ /g, '-'),
            children: option.name
          });
        })
      })]
    })
  });
};
var _default = exports.default = ContextMenu;